import { Phone, PhoneMissed, Check } from "lucide-react";

/**
 * Premium coded "missed-call text-back" mockup: a phone messaging thread showing
 * a missed call instantly auto-replied and booked. Hero visual for the CRM page;
 * proves the speed-to-lead promise without a stock image.
 */
export const MissedCallTextback = () => {
  return (
    <div className="relative w-full max-w-[400px] mx-auto select-none">
      {/* soft brand glow */}
      <div className="absolute -inset-8 -z-10 bg-[radial-gradient(circle_at_70%_25%,rgba(13,148,136,0.20),transparent_60%),radial-gradient(circle_at_25%_85%,rgba(16,185,129,0.14),transparent_60%)] blur-2xl" />

      {/* floating badge */}
      <div className="absolute -top-3 right-4 z-10 rounded-full bg-gradient-to-br from-teal-600 to-emerald-600 px-3.5 py-1.5 text-xs font-bold text-white shadow-lg shadow-teal-900/20">
        Replied in 8 seconds
      </div>

      <div className="relative overflow-hidden rounded-[1.75rem] border border-black/[0.06] bg-white shadow-2xl shadow-teal-900/10">
        {/* contact header */}
        <div className="flex items-center gap-3 border-b border-slate-100 px-4 py-3.5">
          <div className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-gradient-to-br from-teal-500 to-emerald-500 text-sm font-bold text-white">
            ?
          </div>
          <div className="min-w-0 flex-1">
            <div className="truncate text-sm font-bold text-slate-900">New Caller</div>
            <div className="text-xs text-slate-600">(807) 555-0192</div>
          </div>
          <Phone className="h-4 w-4 text-teal-500" />
        </div>

        {/* conversation */}
        <div className="space-y-2.5 p-4">
          {/* missed call event */}
          <div className="flex items-center justify-center gap-1.5 text-xs font-medium text-rose-600">
            <PhoneMissed className="h-3.5 w-3.5" /> Missed call &middot; 2:14 PM
          </div>

          {/* auto text-back (outbound) */}
          <div className="flex justify-end">
            <div className="max-w-[80%] rounded-2xl rounded-br-md bg-gradient-to-br from-teal-600 to-teal-500 px-3.5 py-2 text-xs font-medium leading-relaxed text-white shadow-sm">
              Hey, it&rsquo;s Northside Plumbing. Sorry we missed you! How can we help?
            </div>
          </div>

          {/* customer reply (inbound) */}
          <div className="flex justify-start">
            <div className="max-w-[80%] rounded-2xl rounded-bl-md bg-slate-100 px-3.5 py-2 text-xs font-medium leading-relaxed text-slate-700">
              Burst pipe. Can someone come out today?
            </div>
          </div>

          {/* booked confirmation (outbound) */}
          <div className="flex justify-end">
            <div className="flex max-w-[80%] items-center gap-1.5 rounded-2xl rounded-br-md bg-gradient-to-br from-teal-600 to-teal-500 px-3.5 py-2 text-xs font-medium text-white shadow-sm">
              <Check className="h-3.5 w-3.5 shrink-0" /> Booked you for 4 PM today
            </div>
          </div>
        </div>

        {/* status footer */}
        <div className="flex items-center gap-2 border-t border-slate-100 bg-slate-50/60 px-4 py-2.5">
          <span className="h-2 w-2 rounded-full bg-emerald-500 shadow-[0_0_8px_rgba(16,185,129,0.6)]" />
          <span className="text-xs font-medium text-slate-500">Automated &middot; no one touched a phone</span>
        </div>
      </div>
    </div>
  );
};

export default MissedCallTextback;
